var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[this.$route.matched[0] ? this.$route.matched[0].name : '', this.$route.name],attrs:{"id":"app"}},[_c('MainHeader'),_c('main',[_c('router-view')],1),_c('MainFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }